<section class="feature-wrapper">
  <img class="image" [src]="imageUrl" [alt]="title"/>
  <h3 class="title" translate>{{title}}</h3>
  <p class="description" translate>{{description}}</p>
</section>
